// Loads the Razorpay Checkout SDK once and caches the promise
let scriptPromise = null;

export function loadRazorpay() {
    if (window.Razorpay) return Promise.resolve(true);
    if (scriptPromise) return scriptPromise;
    scriptPromise = new Promise((resolve) => {
        const s = document.createElement("script");
        s.src = "https://checkout.razorpay.com/v1/checkout.js";
        s.onload = () => resolve(true);
        s.onerror = () => { scriptPromise = null; resolve(false); };
        document.body.appendChild(s);
    });
    return scriptPromise;
}
